import axiosServices from 'utils/axios';
import type { AxiosResponse } from 'axios';

/**
 * Quote endpoints consumed by more than one feature (quotes, and shipments' edit controller —
 * which checks for an accepted quote to decide impact-field locking). Split out of the old
 * src/api/quote.js during the features/quotes migration (NEX-1385), mirroring
 * src/shared/api/shipment.ts. Quotes-only endpoints stayed in features/quotes/api.ts instead
 * of moving here.
 */

export const getQuotesByShipment = (shipmentId: number | string): Promise<AxiosResponse<unknown>> =>
  axiosServices.get(`/quotes/by-shipment/${shipmentId}`);
